import PatientRoutes from '@lib/routes/PatientRoutes'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import {
  POST_APPLY_STEPS,
  type PostApplyStep,
} from '../PostApplyPrompt/stepTypes'

export const getApplySuccessRouteToRedirectTo = (
  currentStep: PostApplyStep,
  {
    consentForEmr,
    consentToShareYourStory,
    hasPatientNavigatorAgentCallCompleted,
    idToken,
    patientNavigatorAgentId,
    patientRegistryEnrolled,
    screeningVisitAvailabilities,
    whyAreYouApplying,
  }: Pick<
    ApplySuccessPageProps,
    | 'consentForEmr'
    | 'consentToShareYourStory'
    | 'hasPatientNavigatorAgentCallCompleted'
    | 'idToken'
    | 'patientNavigatorAgentId'
    | 'patientRegistryEnrolled'
    | 'screeningVisitAvailabilities'
    | 'whyAreYouApplying'
  >,
) => {
  const getNextStep = (step: PostApplyStep): PostApplyStep => {
    const currentIndex = POST_APPLY_STEPS.indexOf(step)
    return POST_APPLY_STEPS[currentIndex + 1] as PostApplyStep
  }

  const shouldAdvance = (step: PostApplyStep): boolean => {
    switch (step) {
      case 'medical-release-consent':
      case 'medical-release-signature':
        return (
          consentForEmr?.status === 'Complete' ||
          consentForEmr?.status === 'Pending'
        )
      case 'warm-transfer':
        return true
      case 'screening-visit-availability':
        return screeningVisitAvailabilities.length > 0
      case 'patient-navigator-agent':
        return hasPatientNavigatorAgentCallCompleted || !patientNavigatorAgentId // we already have a completed call or no agentId means patient should advance
      case 'why-apply':
        return !!whyAreYouApplying
      case 'share-story':
        return !!consentToShareYourStory
      case 'registry':
      case 'guardian':
        return patientRegistryEnrolled
      default:
        return false
    }
  }

  let nextStep = currentStep

  while (nextStep && shouldAdvance(nextStep)) {
    nextStep = getNextStep(nextStep)
  }

  if (nextStep) {
    return PatientRoutes.trialApplySurveyPostscreenerConsents(idToken, nextStep)
  }

  return PatientRoutes.applyPackage(idToken)
}
